import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

export const searchSubmitAlgolytics = delayHit((payload: Object) => hitAlgolytics("search_interaction", payload), 500);
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

export const searchSubmitAlgolytics = delayHit((payload: Object) => hitAlgolytics("search_interaction", payload), 500);
